import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchGetUserData, fetchGetUserFields, fetchUpdateUserData, fetchUpdateUserOnboarding } from './userApi';
import { showError } from '../Error/errorSlice';
import { DEFAULT_FIELDS } from '../../config/constants';
import { setLoading } from '../../services/global/globalSlice';
import { GetFromLocalStorage, SaveToLocalStorage } from '../../utils/utils';

const initialState = {
  user_data: null,
  user_fields: null,
  onboarding: GetFromLocalStorage('onboarding') || {},
  is_saved: false,
}

export const loadUserProfileData = createAsyncThunk(
  'userInfo/loadUserProfileData',
  async (_,thunkAPI) => {

      const response = await fetchGetUserData();
      if (response?.success) {
            thunkAPI.dispatch(setLoading(false))
            return response.data
      } else {
        //TO-DO: Aggiungere dispatch errori 
        //dispatch error
      }
  }
);
export const loadUserFieldsData = createAsyncThunk(
  'userInfo/loadUserFieldsData',
  async () => {
      const response = await fetchGetUserFields();
      if (response?.success) {
          return response.data
      } else {
        //TO-DO: Aggiungere dispatch errori 
        //dispatch error
      }
  }
);
export const updateUserData = createAsyncThunk(
  'userInfo/updateUserData',
  async (props, thunkAPI) => {
        const {user_data} = props
        const response = await fetchUpdateUserData(user_data);
        if (response?.success) {
            return response.data
        } else {
            thunkAPI.dispatch(showError('hi'))
        }
  }
);

export const updateUserOnboarding = createAsyncThunk(
  'userInfo/updateUserOnboarding',
  async (props, thunkAPI) => {
        const onboarding_data = props
        console.log(onboarding_data);
        
        if(onboarding_data.onboarding_step.section) {
            const response = await fetchUpdateUserOnboarding({
                onboarding_section_name: onboarding_data?.onboarding_step?.section,
                section_completed: onboarding_data?.onboarding_step?.section_completed
            });
            if (response?.success) {
                return onboarding_data
            } else {
                thunkAPI.dispatch(showError('error onboarding'))
                return onboarding_data
            }
        }
  }
);

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    updateUserField: (state, action) => {
        const field_id = action.payload.field_id
        const value = action.payload.value
        if(action.payload.type === "default")
            state.user_data[field_id] = value
        else{
            let idf = state.user_data.extra_fields.findIndex((e) => e.field_id === field_id);
            if(idf >= 0)
                state.user_data.extra_fields[idf].values = value
            else
                state.user_data.extra_fields.push({field_id:field_id, values:value})
        }
        state.is_saved = false
    },
    resetUserData: (state, action) => {
        state.user_data = null
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(loadUserFieldsData.fulfilled, (state, action) => {
            state.user_fields = action.payload
        })
        .addCase(loadUserProfileData.fulfilled, (state, action) => {
            state.user_data = action.payload
            state.onboarding = action?.payload?.admin_onboarding_completion || {}
            state.is_saved = true
        })
        .addCase(updateUserData.fulfilled, (state, action) => {
            state.user_data = action.payload
            state.is_saved = true
        })
        .addCase(updateUserOnboarding.fulfilled, (state, action) => {
            if(action?.payload){
                state.onboarding = {
                    ...state.onboarding,
                    [action?.payload?.onboarding_step?.section]: {
                        step_completed_count: action.payload?.onboarding_step?.step_completed_count,
                        section_completed: action.payload?.onboarding_step?.section_completed
                    }
                }
                SaveToLocalStorage("onboarding", state.onboarding)
            }
            
            
        })
  },
})
export default userInfoSlice.reducer
export const { updateUserField, resetUserData } = userInfoSlice.actions;

export const selectUserInfo = (state) => state?.userInfo;
export const selectUserData = (state) => state?.userInfo?.user_data;
export const selectUserFields = (state) => state?.userInfo?.user_fields;
export const checkUserFields = (state) => {
    let has_missing = false
    if(state?.userInfo?.user_fields && state?.userInfo?.user_data)
        state?.userInfo?.user_fields?.forEach((f)=>{
            if (f.field_level === 0){
                if(DEFAULT_FIELDS.includes(f.field_id)){
                    if (state?.userInfo?.user_data[f?.field_id] === "" || state?.userInfo?.user_data[f?.field_id] === null)
                        has_missing = true
                }else{
                    if (!state?.userInfo?.user_data?.extra_fields?.find(e => (e.field_id === f.field_id && (e.values !== "" && e.values !== null))))
                        has_missing = true
                } 
            }
        })
    return has_missing
}
export const selectUserOnboarding = (state) => state?.userInfo?.onboarding;